import { render, staticRenderFns } from "./reference-category.vue?vue&type=template&id=3d67df58&scoped=true&"
import script from "./reference-category.vue?vue&type=script&lang=js&"
export * from "./reference-category.vue?vue&type=script&lang=js&"
import style0 from "./reference-category.vue?vue&type=style&index=0&id=3d67df58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67df58",
  null
  
)

export default component.exports